import React, { useEffect, useState } from "react";
import "./App.scss";
import {
  ContentWrap,
  FlexColumn,
  FlexRow,
  Text,
  SlideUpModal,
  ModalOverlay,
} from "./styles/Global";
import * as Global from "./styles/Global";
import { connect, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  HashRouter as Router,
  useParams,
  Outlet,
} from "react-router-dom";
import {
  MdBarChart,
  MdGroups,
  MdNotifications,
  MdPerson,
  MdTrackChanges,
} from "react-icons/md";
import { FaMedal, FaTrophy } from "react-icons/fa6";
import NavTabs, { NAV_TABS_GAP, NAV_TABS_TRACK, useNavDodge } from "./components/NavTabs";
// SCO-2710: old tab strip / BannerLogo when the Profile 2027 flag is off; remove with it.
import { PROFILE_2027 } from "./utils/profile2027Flag";
import { isOn as ui2027On } from "./utils/ui2027Flag";

import "react-toastify/dist/ReactToastify.css";
import "@ant-design/flowchart/dist/index.css";
import { ToastContainer, toast } from "react-toastify";
import loadable from "@loadable/component";
import ChooseSport from "./pages/organizer/modals/ChooseSport";
import packageJson from "../package.json";
import { setGlobal } from "./features/global/globalSlice";
import { readStoredJson, writeStoredJson } from "./functions/safeStorage";
import { nativeOwnsAppearance } from "./functions/appearanceOwner";
import { clearModals, setModal } from "./features/modals/modalSlice";
// import 'react-activity-feed/dist/index.css';

// import SlideUp from "./components/modals/SlideUp";
const BannerLogo = loadable(() => import("./components/BannerLogo"));
// The call site passes a fallback of the row's exact box (28 tall, half of `gap` above and below), so the page never moves.
const ProfileLogoRow = loadable(() => import("./pages/player/components/ProfileLogoRow"));
const ActivityFeedv3 = loadable(
  () => import("./pages/Global/groupFeeds/ActivityFeedv3"),
);

const mapDispatch = {
  setGlobal,
  clearModals,
};

function App({ setGlobal, clearModals }) {
  const { t } = useTranslation();
  // Using the named import to create the client
  const global = useSelector((state) => state.global);
  const darkMode = useSelector((state) => state.global.darkMode);
  const hideNavbar = useSelector((state) => state.global.hideNavbar);
  const params = new URLSearchParams(window.location.search);
  const platform = useSelector((state) => state.organizer.platform);
  const organizer = useSelector((state) => state.organizer.organizerData);
  const isGodPower = useSelector((state) => state.organizer.isGodPower);
  const orgAccountID = useSelector((state) => state.organizer.accountid);
  const organizerId = useSelector((state) => state.organizer.accountid);
  const player = useSelector((state) => state.player);
  const year = new Date().getFullYear();
  // SCO-1870: the strip parks below native chrome and dodges on scroll (NavTabs.useNavDodge).
  const navDodged = useNavDodge();
  // console.log('APP isGodpower: ', isGodPower);
  const allAccessUsers = [
    "PdejK7ZzhMM5nGJPl6QP57wBXBB2",
    "FD2x0TUi1qTD78xj3vdFcSnzW102",
    "irpWsXBhjQRFhK8pNrtnarqDpeF2",
    "ykQkJvXkI6U5nxuAqDyz82z5Fdt1",
  ];
  const notificationsGroupsNav = [
    { to: "notifications", name: t("nav.notifications"), Icon: MdNotifications },
    { to: "groups", name: t("nav.groups"), Icon: MdGroups },
  ];
  const playerNav = [
    { to: "player/profile", name: t("nav.profile"), Icon: MdPerson },
    // Medal = the Rankings card heading icon on the profile.
    { to: "player/rankings", name: t("nav.rankings"), Icon: FaMedal },
    { to: "player/practice", name: t("nav.practice"), Icon: MdTrackChanges },
  ];
  const organizerNav = [
    { to: "organizer", name: t("nav.tournaments"), Icon: FaTrophy },
    // { to: "organizer/players", name: "Players" },
    { to: "organizer/stats", name: t("nav.stats"), Icon: MdBarChart },
    // { to: "organizer/seasons", name: "Seasons" },
  ];
  const navType = new URL(window.location.href).pathname.split("/")[3];
  const segment2 = new URL(window.location.href).pathname.split("/")[2];
  const pathSegments = new URL(window.location.href).pathname.split("/");
  // Stats reached by a reload has no organizer profile (only RAT home loads it); its top bar still works,
  // so Tournaments takes the organizer to RAT home, which loads it.
  const statsNoProfileOk = navType === "organizer" && pathSegments[4] === "stats";
  const navToUse =
    segment2 === "notifications" || segment2 === "groups"
      ? notificationsGroupsNav
      : navType === "organizer"
      ? // ? allAccessUsers.includes(orgAccountID)
        organizerNav
      : // : organizerNav.filter((i) => i.name !== "Seasons")
        playerNav;
  const [viewType, setViewType] = useState(0);
  const { sport } = useParams();
  //console.log(sport);
  // console.log("App organizer: ", organizer);
  console.log("App player: ", player);
  // console.log("App platform: ", platform);
  console.log("App navType: ", navType);

  useEffect(() => {
    const localStorageGlobal = JSON.parse(localStorage.getItem("global")) || {};
    console.log("App localStorageGlobal: ", localStorageGlobal);
    const isOverlay =
      new URL(window.location.href).pathname.split("/")[3] === "overlay";
    // SCO-2200: only under the NEW chrome does the native menu own appearance
    // (?mode= single source of truth) — legacy apps keep the web override.
    const inApp = nativeOwnsAppearance();
    const darkMode = isOverlay
      ? false
      : inApp
      ? params.get("mode") === "dark"
      : localStorageGlobal &&
        localStorageGlobal.hasOwnProperty("useCustomTheme") &&
        localStorageGlobal.useCustomTheme
      ? localStorageGlobal.customTheme
      : params.get("mode") !== "light"
      ? params.get("mode") === "dark" ||
        (localStorageGlobal && localStorageGlobal.darkMode)
      : false;
    console.log("App.js darkMode: ", darkMode);

    setGlobal({
      darkMode: darkMode,
    });

    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  useEffect(() => {
    console.log("App.jsx darkMode: ", darkMode);
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);

  // SCO-2200 r4: the native menu's Appearance toggle pushes the resolved
  // mode into live webviews — apply + persist so open pages re-theme
  // seamlessly and future param-less loads agree with the device setting.
  useEffect(() => {
    window.__setAppearance__ = (mode) => {
      const dark = mode === "dark";
      writeStoredJson("global", { ...readStoredJson("global", {}), darkMode: dark });
      setGlobal({ darkMode: dark });
    };
    return () => {
      delete window.__setAppearance__;
    };
  }, []);

  useEffect(() => {
    if (platform) {
      // console.log("set body class mobile");
      document.body.classList.add("mobile");
    }
  }, [platform]);

  window.closeModals = async function () {
    try {
      console.log("closeModals called from window");
      clearModals();
    } catch (error) {
      console.log(error);
      console.log("window.closeModals ERROR: ", error);
    }
  };

  const sportless = segment2 === "notifications" || segment2 === "groups";
  const slimHeader =
    (PROFILE_2027 && navType === "player" && ["profile", "practice", "rankings"].includes(pathSegments[4])) ||
    // RAT 2027 home (SCO-2742) and Stats (SCO-2755).
    (ui2027On("rat") && navType === "organizer" && (!pathSegments[4] || pathSegments[4] === "stats"));
  // Above and below the tab strip: the page's own card gap (Phil 2026-10-21); one value on every 2027 page, so the
  // strip never shifts between them (Phil 2026-11-02: RAT home's 12 moved it against Stats).
  const tabGap = !slimHeader ? NAV_TABS_GAP : 16;
  const tabs =
    isGodPower || hideNavbar ? null : (
      <NavTabs
        items={navToUse.map((item) => ({
          ...item,
          path: sportless ? item.to : `${sport}/${item.to}`,
        }))}
        disabled={
          !sportless &&
          ((navType === "organizer" && !organizer && !statsNoProfileOk) ||
            (navType === "player" && player.isUnverified))
        }
        dodged={navDodged}
        topGap={tabGap}
        // 2027 pages: the strip under the logo row, sticking at the top once scrolled to (Phil 2026-11-02); half the
        // gap under the strip.
        stacked={slimHeader}
        bottomGap={tabGap / 2}
      />
    );
  return (
    <ContentWrap
      maxWidth={isGodPower ? null : "600px"}
      style={{
        paddingTop:
          !isGodPower && !hideNavbar && !slimHeader
            ? `calc(${tabGap + NAV_TABS_TRACK}px + var(--sh-chrome-top, 0px))`
            : "var(--sh-chrome-top, 0px)",
      }}
    >
      {navType || segment2 === "notifications" || segment2 === "groups" ? (
        <>
          <>
            {slimHeader ? null : tabs}

            <FlexColumn align="center">
              {isGodPower ||
              hideNavbar ||
              segment2 === "notifications" ||
              segment2 === "groups" ? null : slimHeader ? (
                <>
                  {/* The stand-in copies ProfileLogoRow's LOGO_ROW_MARGIN (16 above, 12 under). */}
                  <ProfileLogoRow
                    gap={tabGap}
                    fallback={<div aria-hidden="true" style={{ width: "100%", maxWidth: 600, height: 28, margin: "16px auto 12px" }} />}
                  />
                  {tabs}
                </>
              ) : (
                <BannerLogo viewType={viewType} />
              )}
              <Outlet />
              <FlexRow
                align="center"
                justify="center"
                style={{ marginBottom: 10 }}
              >
                <Text size=".7em">
                  v{process.env.REACT_APP_VERSION} Build: {packageJson.build} ©
                  Scoreholio {year}
                </Text>
              </FlexRow>
            </FlexColumn>
          </>
        </>
      ) : (
        <>
          <SlideUpModal maxWidth={"600px"} className="showModalWeb">
            <ChooseSport isHome={true} />
          </SlideUpModal>
          <ModalOverlay
            background={"transparent"}
            className="showModal showOverlay"
          />
        </>
      )}
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </ContentWrap>
  );
}

export default connect(null, mapDispatch)(App);
